import { cloneDeep } from "lodash";
import { AbstractLookupStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import { AttachmentDto } from "../generated";
import Actions from "./attachmentsActions";

export class AttachmentsStore extends AbstractLookupStore<AttachmentDto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.get, result => this.set(this.getKey(result.resourceName, result.resourceId), result.data!))
            .onfunction(Actions.delete, result => {
                const key = this.getKey(result.resourceName, result.resourceId);
                let items = this.get(key) || [];
                const ix = items.findIndex(x => x.key == result.key);
                if (ix >= 0) {
                    let newItems = cloneDeep(items);
                    newItems.splice(ix, 1);
                    if (newItems.length > 0)
                        this.set(key, newItems);
                    else
                        this.delete(key);
                }
            })
            .onfunction(Actions.upload, result => {
                const key = this.getKey(result.folder, result.subfolder)
                let items = this.get(key) || [];
                let newItems = cloneDeep(items);
                newItems.push(result.data);
                this.set(key, newItems);
            });
    }

    private getKey(resourceName: string, resourceId: string) {
        return JSON.stringify({ resourceName, resourceId });
    }

    getByResource(resourceName: string, resourceId: string) {
        return this.get(this.getKey(resourceName, resourceId)) || [];
    }
}

export default new AttachmentsStore();